module.exports = __webpack_public_path__ + "img/sup_deposit_bank1.94e54ddd.jpg";